export default __webpack_public_path__ + "static/media/instagram.e71ee27a.svg";